/* iurop-footer.js — Newsletter del footer con alta en Klaviyo vía API cliente.
   El form lleva data-klaviyo-key (Public API Key / company_id) y data-klaviyo-list (List ID),
   configurables en los ajustes del footer. Sin esas dos claves, el form no envía (avisa).
   Docs: POST https://a.klaviyo.com/client/subscriptions/  (revision 2024-10-15). */
(function () {
  'use strict';

  function init() {
    var forms = document.querySelectorAll('form[data-klaviyo-form]');
    for (var i = 0; i < forms.length; i++) {
      bind(forms[i]);
    }
  }

  function bind(form) {
    if (form.dataset.klaviyoBound) return;
    form.dataset.klaviyoBound = '1';

    var msg = form.parentNode ? form.parentNode.querySelector('[data-klaviyo-msg]') : null;
    var input = form.querySelector('input[type="email"]');
    var btn = form.querySelector('button[type="submit"]');

    function show(text, isError) {
      if (!msg) return;
      msg.textContent = text;
      msg.hidden = false;
      msg.setAttribute('data-state', isError ? 'error' : 'ok');
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = input ? input.value.trim() : '';
      if (!email || email.indexOf('@') === -1) {
        show(form.getAttribute('data-msg-error') || 'Invalid email.', true);
        return;
      }

      var key = form.getAttribute('data-klaviyo-key');
      var list = form.getAttribute('data-klaviyo-list');
      if (!key || !list) {
        show(form.getAttribute('data-msg-error') || 'Newsletter not configured yet.', true);
        return;
      }

      if (btn) btn.disabled = true;

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(key), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
          revision: '2024-10-15'
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Footer newsletter',
              profile: { data: { type: 'profile', attributes: { email: email } } }
            },
            relationships: { list: { data: { type: 'list', id: list } } }
          }
        })
      })
        .then(function (res) {
          if (res.ok || res.status === 202) {
            form.reset();
            show(form.getAttribute('data-msg-success') || 'Thanks for subscribing!', false);
          } else {
            show(form.getAttribute('data-msg-error') || 'Something went wrong. Please try again.', true);
          }
        })
        .catch(function () {
          show(form.getAttribute('data-msg-error') || 'Something went wrong. Please try again.', true);
        })
        .finally(function () {
          if (btn) btn.disabled = false;
        });
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
